<template>
  <section id="section-2" >
    <form>
      <div class="row">
        <div class="col-md-10">
          <h4>مجوزها</h4>
        </div>
        <div class="col-md-2" title="افزودن مجوز جدید" style="text-align: left">
          <i class="icon-list-add icon-top add-color" @click.prevent="addLine()"></i>
        </div>
      </div>
      <div v-for="(line, index) in lines" :key="index">
        <div class="card-margin">
          <div class="row">
            <div class="col-md-6">
              <div class="select">
                <select class="select-text" v-model="line.licenseType">
                  <option v-for="item in licenseTypes" :value="item.key" :key="item.key">
                    {{ item.value }}
                  </option>
                </select>

                <span class="select-highlight"></span>
                <span class="select-bar"></span>

                <label class="select-label">نوع مجوز</label>
              </div>
            </div>

            <div class="col-md-6">
              <div class="group_mdi">
                <input v-model="line.licenceNumber" />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>شماره مجوز</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="group_mdi inputContainer">
                <div class="icon-position">
                  <i class="icon_calendar icon"></i>
                </div>
                <input v-datepicker :value="convertDate(line.issueDate)"
                  @change="line.issueDate = $event.detail.GregorianDate" />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>تاریخ صدور</label>
              </div>
            </div>

            <div class="col-md-6">
              <div class="group_mdi inputContainer">
                <div class="icon-position">
                  <i class="icon_calendar icon"></i>
                </div>
                <input v-datepicker :value="convertDate(line.expirationDate)"
                  @change="line.expirationDate = $event.detail.GregorianDate" />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>تاریخ اعتبار</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-11">
              <textarea class="style-textarea" placeholder="توضیحات" type="text" v-model="line.description" style="margin-right: 25px;"/>
              <span class="highlight"></span>
              <span class="bar"></span>
            </div>
            <div class="col-md-1" title="حذف مجوز ">
              <i class="icon-trash-2 icon-bottom remove-color vertical-center" @click.prevent="removeLine(index)"></i>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="btn-align">
        <button type="submit" class="btn btn-primary" @click.prevent="save" v-if="!isEditMode">
          ثبت
        </button>
        <button type="submit" class="btn btn-primary" @click.prevent="edit" v-if="isEditMode">
          ویرایش
        </button>
        <button type="submit" class="btn btn-danger" @click.prevent="goBackToList">
          بازگشت
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import store from "../../views/profile/store/index";
import moment from "moment-jalaali";

export default {
  name: "License",
  store: store,

  data() {
    return {
      lines: [],
      blockRemoval: true,
      licenseType: "",
      licenceNumber: "",
      issueDate: "",
      expirationDate: "",
      description: "",
      sourceId: "",
      licenseInfoList: [],

      licenseTypes: [
        { key: 1, value: "بند الف" },
        { key: 2, value: "بند ب" },
        { key: 3, value: "بند پ" },
        { key: 4, value: "توریسم درمانی" },
        { key: 5, value: "سایر" },
      ],
      isEditMode: false,
      now: moment(),
    };
  },
  watch: {
    lines() {
      this.blockRemoval = this.lines.length <= 1;
    },
  },
  methods: {
    convertDate(date) {
      if (!moment(date).isValid()) return "";
      const pdate = moment(date).format("jYYYY/jMM/jDD");
      return pdate;
    },
    async getSourceId() {
      this.sourceId = this.$store.getters.GetSourceId;
      this.fetchData(this.sourceId);
    },

    addLine() {
      let checkEmptyLines = this.lines.filter((line) => line.number === null);

      if (checkEmptyLines.length >= 1 && this.lines.length > 0) {
        return;
      }

      this.lines.push({
        licenseType: this.licenseType,
        licenceNumber: this.licenceNumber,
        issueDate: this.issueDate,
        expirationDate: this.expirationDate,
        description: this.description,
        sourceId: this.sourceId,
      });
    },

    removeLine(lineId) {
      if (!this.blockRemoval) {
        this.lines.splice(lineId, 1);
      }
    },

    removeEmptyLine(lineId) {
      this.lines.splice(lineId, 1);
    },

    async fetchData() {
      this.licenseInfoList = await this.$store
        .dispatch("GetLicenseInSource", this.sourceId)
        .then((response) => {
          if (
            response.licenseInfo != undefined ||
            response.licenseInfo != null
          ) {
            this.licenseInfoList = JSON.parse(response.licenseInfo);

            this.removeEmptyLine(0);
            this.licenseInfoList.forEach((element) => {
              this.licenseType = element.licenseType;
              this.licenceNumber = element.licenceNumber;
              this.issueDate = element.issueDate;
              this.expirationDate = element.expirationDate;
              this.description = element.description;

              this.addLine();

              this.licenseType = "";
              this.licenceNumber = "";
              this.issueDate = "";
              this.expirationDate = "";
              this.description = "";
              this.description = "";

              this.isEditMode = true;
            });
          } else {
            this.addLine();
            this.licenseType = "";
            this.licenceNumber = "";
            this.issueDate = "";
            this.expirationDate = "";
            this.description = "";

            this.isEditMode = false;
          }
        });
    },

    save() {
      this.$store
        .dispatch("UpdateLicenseInfo", {
          licensesInfo: this.lines,
          id: this.sourceId,
        })
        .then(() => {
          // alert("ثبت اطلاعات با موفقیت انجام گردید");
          this.$toast.success("ثبت اطلاعات با موفقیت انجام گردید", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        });
    },

    edit() {
      this.$store
        .dispatch("UpdateLicenseInfo", {
          licensesInfo: this.lines,
          id: this.sourceId,
        })
        .then(() => {
          // alert("ویرایش اطلاعات با موفقیت انجام گردید");
          this.$toast.success("ویرایش اطلاعات با موفقیت انجام گردید", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        });
    },

    goBackToList() {
      this.$router.push({ name: "userBusinessList" });
    },
  },
  mounted() {
    this.getSourceId();
  },
};
</script>
<style scoped>
.icon-top {
  margin-top: 38px;
  font-size: 40px;
}

.icon-bottom {
  margin-top: 38px;
  font-size: 22px;
}

.icon-position {
  float: left;
  margin-left: 26px;
}

.add-color {
  color: #64d3e8;
}

.remove-color {
  color: red;
}

.card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  margin-top: 20px !important;
}

.card-margin {
  margin: 25px;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 65%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>